// ============================================================
// หน้า RecordReceipt — รับชำระค่าใช้จ่าย (ออกใบเสร็จค่าน้ำ)
// ------------------------------------------------------------
// หน้าหลักของงานรับเงิน: เลือกบ้านเลขที่ → ระบบรวมยอดค้างทุกงวดมาให้ → รับเงิน → พิมพ์ใบเสร็จ
//
// ลำดับการทำงาน
//   1. โหลดตั้งค่าโครงการ + เลขที่ใบแจ้งหนี้ถัดไป + รายชื่อบ้านเลขที่
//   2. เลือกบ้าน → ดึงบิลค้างทุกงวด แล้วรวมเป็น "รายการที่ต้องชำระ" 11 ช่อง (payment_list)
//   3. ปุ่ม "ชำระบางส่วน" = เลือกว่าจะชำระงวดไหนบ้าง (ต้องไล่จากงวดเก่าไปใหม่ และเป็นลูกหนี้คนเดียวกัน)
//   4. ปุ่ม "แก้ไข" = ขอสิทธิ์ (ยืนยันชื่อผู้ใช้/รหัสผ่าน) เพื่อติ๊กเลือกเฉพาะบางช่อง
//   5. กด "พิมพ์ใบเสร็จ" → popup รับเงิน (ปรับเศษ/เพิ่มหนี้/ลดหนี้) → บันทึก + พิมพ์
//
// หลังบันทึกสำเร็จจะคิดยอดค้าง/เบี้ยปรับของบ้านหลังนั้นใหม่ (calculate_water)
// ============================================================

import React, { Component } from "react";
import Select from "react-select";
import Resizer from "react-image-file-resizer";
import { Modal } from "react-bootstrap";

import "../../shared/config/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../shared/layout/Navbar";
import {
  loading,
  tokens,
  select_style,
  total,
  alert,
  alert_url,
  toFixed,
  GET,
  POST,
  format_date,
  float,
  validate,
  required,
  DatePicker,
  NumberZero,
  getStorage,
  roundTo,
  calculate_water,
  getWaterSetting,
  calcFireCost,
  permission,
  printReceiptByIwNumber,
  PAYMENT_TITLES,
  PAYMENT_KEYS,
  signOf,
  isDone,
  unpaidAmountOf,
  calcChangeSatang,
} from "../../shared/index.js";

const perm = permission("record-receipt");

// วิธีการชำระเงิน
const PAYMENT_CASH = 1;
const PAYMENT_TRANSFER = 2;

// รายการที่ต้องชำระตั้งต้น 11 ช่อง (ยังไม่เลือกบ้าน)
const INITIAL_PAYMENT_LIST = PAYMENT_KEYS.map((key) => ({ title: key, cost: 0.0, status_pay: false }));

// ค่าที่ backend อาจส่งมาเป็นข้อความมี comma ต้องแปลงเป็นตัวเลขก่อนคิด
const COMMA_FIELDS = ["late_payment", "common_expenses", "cable_cost", "fire_cost"];
const parseCost = (value) => Number(String(value || 0).replace(/,/g, ""));

// รวมยอดค้างของทุกงวดที่เลือก ออกมาเป็นรายการที่ต้องชำระ 11 ช่อง
const buildPaymentList = (rows) =>
  PAYMENT_KEYS.map((key) => ({
    title: key,
    status_pay: true,
    cost: total(rows.filter((row) => !isDone(row, key)), key) * signOf(key),
  }));

export default class RecordReceipt extends Component {
  constructor(props) {
    super(props);
    const now = new Date();
    this.state = {
      // popup / สถานะหน้าจอ
      disable_button: false,
      modal_pay: false, // popup รับเงิน
      modal_some_pay: false, // popup เลือกชำระบางส่วน
      modal_permission: false, // popup ขอสิทธิ์แก้ไข
      editable: false, // ได้สิทธิ์ติ๊กเลือกรายการแล้วหรือยัง
      username: "",
      password: "",

      // ข้อมูลผู้ชำระ
      data_customer: null,
      customer_id: "",
      ref_customer_id: "",
      address_number: "",
      address_text: "",
      full_name: "",
      project_name: "",
      address: "",

      // บิลค้าง
      record_water_list: [], // บิลค้างทุกงวดของบ้านที่เลือก
      record_water_list_change: [], // สำเนาที่ใช้ใน popup ชำระบางส่วน
      sum_unit_used: 0,

      // ใบเสร็จ
      iw_number: "",
      record_date: now,
      record_time: NumberZero(now.getHours()) + ":" + NumberZero(now.getMinutes()),
      payment_type: PAYMENT_CASH,
      transfer_date: "",
      transfer_time: "",
      photo: "",
      is_upload_slip: false,
      payment_list: JSON.parse(JSON.stringify(INITIAL_PAYMENT_LIST)),
      record_other_list: [],
      clement_remark: "",

      // ยอดเงิน
      total_amount: 0.0, // ยอดที่ต้องชำระ
      total_final: 0.0, // ยอดสุทธิก่อนปรับเศษ/เพิ่ม-ลดหนี้
      change_satang: 0.0, // ปรับเศษสตางค์
      add_on_add_debt: 0, // เพิ่มหนี้ตอนรับชำระ
      add_on_reduce_debt: 0, // ลดหนี้ตอนรับชำระ
      add_on_add_debt_remark: "",
      add_on_reduce_debt_remark: "",
      total_pay: 0.0, // เงินที่รับมาจริง

      // ค่าจากตั้งค่าโครงการ
      setting_water_id: getStorage("water_id"),
      water_charge_start: 0,
      water_charge_end: 0,
      water_charge_price: 0,
      water_rate_list: [],
      penalty_day_list: [],
      penalty_month_list: [],
      payment_deadline: 0,
      common_expenses_type: false,
      common_expenses_text: 0,
      fire_month: "",
      fire_cost: 0,
      date_of_note: now,
    };
  }

  async componentDidMount() {
    if (!perm.view) return;
    await Promise.all([this.GetSetting(), this.GetRunningNumber(), this.GetCustomerAll()]);
    if (this.props.location.query.address_number) await this.GetByAddressNumber(this.props.location.query.address_number);
  }

  // ---------- โหลดข้อมูล ----------

  // ตัวเลือกบ้านเลขที่ (แสดงเป็น "อาคาร x ห้อง y")
  GetCustomerAll = async () => {
    const result = await GET(tokens, `v1/TH/customer-manage/filter-search/page/0/${getStorage("project_id")}`, { data_search: "", transfer_date: "", status_transfer: "" });
    if (result?.status) {
      this.setState({ data_customer: result.data.data.map((item) => ({ value: item.address_number, label: `อาคาร ${item.building} ห้อง ${item.address_number}` })) });
    }
  };

  // เลขที่ใบแจ้งหนี้ตัวถัดไป
  GetRunningNumber = async () => {
    const result = await GET(tokens, `v1/TH/record-receipt/running-iw/${getStorage("project_id")}`, { format_doc: "IW" });
    if (result?.status) {
      this.setState({ iw_number: result.data.data });
      // คืนเลขตรงๆ ให้ผู้เรียกใช้ทันที (ไม่พึ่ง this.state ที่ setState ยังไม่ทันอัปเดต)
      return result.data.data;
    }
    return null;
  };

  // เลขที่ใบเสร็จจริงจาก response (backend อาจออกเลขใหม่ให้ถ้าเลขที่ส่งไปชน) · ไม่มีมา = ใช้เลขที่ส่งไป
  pickIwNumber = (result, sent) => {
    const d = result?.data;
    const n = (d && typeof d === "object" ? d.iw_number : null) || result?.iw_number;
    return n ? String(n) : sent;
  };

  GetSetting = async () => {
    loading(true);
    const d = await getWaterSetting(this.state.setting_water_id);
    if (d) {
      // หา "รอบเดือน" ที่ควรรับชำระ — ยังไม่ถึงวันครบกำหนด แปลว่ายังอยู่ในรอบของเดือนก่อน
      const date_of_note = d.payment_deadline ? new Date(new Date().setDate(Number(d.payment_deadline))) : new Date();
      if (d.payment_deadline && new Date() < date_of_note) date_of_note.setMonth(date_of_note.getMonth() - 1);

      this.setState({
        ...d,
        water_charge_start: Number(d.water_charge.water_charge_start),
        water_charge_end: Number(d.water_charge.water_charge_end),
        water_charge_price: toFixed(Number(d.water_charge.water_charge_price)),
        fire_cost: calcFireCost(d, format_date(new Date(), "m")),
        common_expenses_text: d.common_expenses,
        date_of_note,
      });

      // ตั้งค่าไม่ครบ = คิดเงินไม่ได้ ต้องไล่ไปตั้งค่าก่อน
      if (!d.payment_close_time || !d.meter_cut_date || !d.penalty_day_list.length || !d.penalty_month_list.length) {
        alert_url("warning", "แจ้งเตือน", "ท่านยังไม่ทำการตั้งค่าอัตราค่าน้ำก่อนทำการเริ่มต้นใช้งานระบบ", "/manage-water");
      }
    }
    loading(false);
  };

  // โหลดบิลค้างทุกงวดของบ้านที่เลือก แล้วสรุปเป็นรายการที่ต้องชำระ
  GetByAddressNumber = async (address_number) => {
    this.setState({ address_number });
    const result = await GET(tokens, `v1/TH/record-receipt/by-address/${getStorage("project_id")}`, { address_number });
    if (!result?.status) return;

    this.setState({ editable: false });
    const rows = result.data.data;

    if (!rows.length) {
      alert("warning", "แจ้งเตือน", "ไม่มีใบแจ้งหนี้");
      this.clear_form();
      return;
    }

    rows.forEach((d) => {
      COMMA_FIELDS.forEach((k) => (d[k] = parseCost(d[k])));
      d.total_amount = unpaidAmountOf(d);
      d.status = true; // ตั้งต้นเลือกชำระทุกงวด
    });

    // ชื่อผู้ชำระใช้ของงวดที่ติ๊กไว้ (ถ้ายังไม่เคยเลือก ใช้งวดแรก)
    const nameIndex = Math.max(0, this.state.record_water_list_change.findIndex((item) => item.checked));
    const lastRow = rows[rows.length - 1];

    this.setState({
      ref_customer_id: rows[0].ref_customer_id,
      customer_id: lastRow.customer_id,
      full_name: rows[nameIndex].full_name,
      project_name: getStorage("project_name"),
      address: lastRow.address || lastRow.address_number,
      address_text: lastRow.address || lastRow.address_number,
      record_water_list: rows,
      clement_remark: "",
      total_amount: roundTo(total(rows, "total_amount"), 2),
      change_satang: 0.0,
      total_final: roundTo(total(rows, "total_amount"), 2),
      sum_unit_used: roundTo(total(rows, "unit_used"), 2),
      payment_list: buildPaymentList(rows),
    });
  };

  // ---------- บันทึกใบเสร็จ ----------

  // ยอดสุทธิที่ต้องเก็บจริง (รวมปรับเศษ + เพิ่มหนี้ - ลดหนี้)
  finalAmount = () => Number(this.state.total_final) + Number(this.state.change_satang) + Number(this.state.add_on_add_debt) - Number(this.state.add_on_reduce_debt);

  // กันกดซ้ำด้วย flag บน instance (setState ยังไม่ทันอัปเดตตอนกดรัว) และรีเซ็ตปุ่มทุกทางด้วย finally
  Create = async () => {
    if (this._creating) return;
    this._creating = true;
    try {
      await this._create();
    } finally {
      this._creating = false;
      loading(false);
      this.setState({ disable_button: false });
    }
  };

  _create = async () => {
    const { payment_list, record_water_list, change_satang, add_on_add_debt, add_on_reduce_debt, total_pay, record_date, project_name, transfer_date, transfer_time, photo, address_number } = this.state;

    // เรียงงวดใหม่ไปเก่า
    const sortedRows = [...record_water_list].sort((a, b) => new Date(b.datetime_create) - new Date(a.datetime_create));
    const finalAmount = this.finalAmount();

    // NOTE เดิมเด้ง popup เตือนแล้วไม่ return — ใบเสร็จถูกบันทึกต่อทั้งที่เงินที่รับน้อยกว่ายอดที่ต้องชำระ
    //      (หรือยอดติดลบ) ตอนนี้หยุดจริง ไม่บันทึก
    if (Number(total_pay) - finalAmount < 0 || finalAmount < 0) {
      alert("warning", "แจ้งเตือน", finalAmount < 0 ? "ยอดชำระไม่สามารถน้อยกว่า 0 ได้" : "จำนวนเงินที่รับน้อยกว่ายอดชำระ");
      return;
    }

    loading(true);
    this.setState({ disable_button: true });

    // ขอเลขที่ล่าสุดอีกครั้งก่อนบันทึก กันชนกับผู้ใช้คนอื่น
    // ใช้เลขที่ได้จากการขอใหม่ตรงๆ ถ้าขอไม่ได้ค่อยใช้เลขเดิมใน state
    const sent_iw_number = (await this.GetRunningNumber()) || this.state.iw_number;

    // ลดหนี้เก็บเป็นค่าบวกเสมอ และช่องที่ยอดเป็น 0 ไม่ถือว่าชำระ
    const finalPaymentList = payment_list.map((p) => ({
      ...p,
      cost: p.title === "reduce_debt" && p.cost < 0 ? p.cost * -1 : p.cost,
      status_pay: p.cost !== 0 && p.status_pay,
    }));

    // ทำเครื่องหมายว่างวดไหนถูกเก็บช่องใดบ้างในการรับชำระครั้งนี้
    // ช่องที่จบไปแล้ว (ชำระ/ตัดหนี้) จะไม่ถูกทำเครื่องหมายซ้ำ
    const transaction_payments = sortedRows
      .filter((e) => e.status)
      .map((item) => {
        const updated = { ...item };
        finalPaymentList.forEach((p) => {
          updated[`s_${p.title}`] = !!(p.status_pay && !isDone(item, p.title));
        });
        return updated;
      });

    const data = {
      ...this.state,
      iw_number: sent_iw_number,
      record_date: new Date(record_date).toISOString().split("T")[0],
      project_name,
      agency_name: project_name,
      transfer_date: transfer_date || null,
      transfer_time: transfer_time || null,
      record_water_list: sortedRows.filter((item) => item.status).map((item) => item.record_water_id),
      total_final: finalAmount,
      change_satang: Number(change_satang),
      add_on_add_debt: Number(add_on_add_debt),
      add_on_reduce_debt: Number(add_on_reduce_debt),
      photo: photo || "",
      transaction_payments,
      payment_list: finalPaymentList,
    };

    const result = await POST(tokens, "v1/TH/record-receipt/create/" + getStorage("project_id"), data);
    if (result?.status) {
      const iw_number = this.pickIwNumber(result, sent_iw_number);
      alert_url("success", "สำเร็จ", `บันทึกใบเสร็จหมายเลข "${iw_number}" สำเร็จแล้ว`, "/record-receipt");
      await Promise.all([
        this.GetSetting(),
        // รับเงินแล้วยอดค้าง/เบี้ยปรับของบ้านหลังนี้เปลี่ยน ต้องคิดใหม่
        calculate_water(address_number || ""),
        printReceiptByIwNumber(iw_number, this.clear_form),
        this.GetRunningNumber(),
      ]);
      if (this.props.location.query.address_number) await this.GetByAddressNumber(this.props.location.query.address_number);
    }
  };

  // ขอสิทธิ์แก้ไข (ยืนยันชื่อผู้ใช้/รหัสผ่านของผู้มีสิทธิ์)
  updatePermission = async () => {
    loading(true);
    const result = await POST(tokens, "v1/TH/record-receipt/check-box-confirm", { username: this.state.username, password: this.state.password });
    if (result?.status) this.setState({ editable: true, modal_permission: false });
    loading(false);
    this.setState({ username: "", password: "" });
  };

  // ---------- ตารางรายการที่ต้องชำระ ----------

  // ยอดรวม = ผลรวมของช่องที่ติ๊กไว้
  calTotalAmount = () => {
    const totalCost = roundTo(total(this.state.payment_list.filter((item) => item.status_pay), "cost"), 2);
    this.setState({ total_amount: totalCost, total_final: totalCost });
  };

  handlePaymentCheckboxChange = (index) => {
    const payment_list = [...this.state.payment_list];
    payment_list[index].status_pay = !payment_list[index].status_pay;
    this.setState({ payment_list }, this.calTotalAmount);
  };

  handleAllPaymentCheckboxChange = (e) => {
    this.setState({ payment_list: this.state.payment_list.map((p) => ({ ...p, status_pay: e.target.checked })) }, this.calTotalAmount);
  };

  // ---------- popup ชำระบางส่วน ----------

  openSomePay = () => this.setState({ modal_some_pay: true, record_water_list_change: this.state.record_water_list.map((e) => ({ ...e, checked: e.status })) });

  closeSomePay = () => this.setState({ modal_some_pay: false, record_water_list_change: [] });

  // ติ๊กงวดใน popup ชำระบางส่วน
  //   - ติ๊กงวดใด = ติ๊กงวดที่เก่ากว่าทั้งหมดให้ด้วย (ต้องชำระไล่จากเก่าไปใหม่)
  //   - เอาติ๊กออก = เอาติ๊กงวดที่ใหม่กว่าออกด้วย
  //   - เลือกข้ามลูกหนี้คนละคนไม่ได้
  toggleSomePayRow = (index, checked) => {
    const item = this.state.record_water_list_change[index];
    const refId = this.state.ref_customer_id || item.ref_customer_id;

    if (refId !== "" && refId !== item.ref_customer_id) {
      alert("warning", "แจ้งเตือน", "ไม่สามารถเลือกบิลที่มีลูกหนี้ต่างกันกันได้");
      return;
    }

    const list = [...this.state.record_water_list_change];
    list.forEach((el, i) => {
      if (checked && i <= index && refId === el.ref_customer_id) el.checked = true;
      else if (!checked && i > index) el.checked = false;
    });
    list[index].checked = checked;

    this.setState({ ref_customer_id: list.some((el) => el.checked) ? item.ref_customer_id : "", record_water_list_change: list });
  };

  // ยืนยันงวดที่เลือกใน popup ชำระบางส่วน แล้วคิดยอดใหม่
  confirmSomePay = () => {
    const list = this.state.record_water_list_change.map((e) => ({ ...e, status: e.checked }));
    const selected = list.filter((item) => item.status);

    if (!selected.length) {
      if (!list.some((e) => e.status)) this.setState({ ref_customer_id: "" });
      alert("warning", "แจ้งเตือน", "กรุณาเลือกอย่างน้อย 1 บิล");
      return;
    }

    this.setState({
      modal_some_pay: false,
      full_name: list[Math.max(0, list.findIndex((e) => e.checked))].full_name,
      record_water_list: list,
      record_water_list_change: [],
      payment_list: buildPaymentList(selected),
      total_amount: roundTo(total(selected, "total_amount"), 2),
      total_final: roundTo(total(selected, "total_amount"), 2),
      sum_unit_used: roundTo(total(selected, "unit_used"), 2),
    });
  };

  // ---------- popup รับเงิน ----------

  // ตรวจฟอร์มก่อนเปิด popup รับเงิน + คำนวณเศษสตางค์ให้ล่วงหน้า
  openPayModal = () => {
    const { total_amount, total_final, payment_type } = this.state;
    if (total_amount === 0) return alert("warning", "แจ้งเตือน", "กรุณาเลือกชำระอย่างน้อย 1 รายการ");

    const required_fields = ["customer_id", "record_water_list", "record_date", "record_time", "iw_number", "payment_type", "full_name", "project_name", "address", "sum_unit_used", "payment_list", "total_amount", "total_final"];

    if (payment_type === PAYMENT_TRANSFER) {
      required_fields.push("transfer_date", "transfer_time");
      if (this.state.is_upload_slip && !this.state.photo.length) return alert("warning", "แจ้งเตือน", "กรุณาอัพโหลดสลิปการโอนเงิน");
    }
    if (validate(this.state, required_fields)) return;

    // เงินโอนไม่ต้องปัดเศษ เงินสดปัดขึ้นขั้นละ 25 สตางค์
    const satang = payment_type === PAYMENT_CASH ? calcChangeSatang(total_final) : 0;
    this.setState({ modal_pay: true, change_satang: satang, total_pay: Number(total_final) + satang });
  };

  // อัปโหลดสลิป — ย่อเป็น 720x720 แล้วเก็บเป็น base64 (เลือกได้หลายรูป)
  // NOTE เดิมใช้ push ใน callback แล้วนับความยาว — ลำดับรูปสลับตามใครย่อเสร็จก่อน
  //      และถ้ามีรูปใดย่อไม่สำเร็จ จะไม่ setState เลย (สลิปหายเงียบ ๆ)
  //      ตอนนี้รอครบทุกรูปด้วย Promise.all แล้วเก็บตามลำดับที่ผู้ใช้เลือก
  handleImageUpload = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    const resize = (file) =>
      new Promise((resolve) => {
        try {
          Resizer.imageFileResizer(file, 720, 720, "JPG", 100, 0, (uri) => resolve(uri?.split(",")[1] || null), "base64");
        } catch (err) {
          console.error(err);
          resolve(null);
        }
      });

    const photos = (await Promise.all(files.map(resize))).filter(Boolean);
    if (photos.length !== files.length) alert("warning", "แจ้งเตือน", "มีรูปบางรูปอัพโหลดไม่สำเร็จ กรุณาลองใหม่");
    this.setState({ photo: photos });
  };

  clear_form = () =>
    this.setState({
      modal_pay: false,
      modal_some_pay: false,
      editable: false,
      username: "",
      password: "",
      address_text: "",
      customer_id: "",
      record_water_list: [],
      record_water_list_change: [],
      record_date: new Date(),
      record_time: format_date(new Date(), "hh:mm"),
      payment_type: PAYMENT_CASH,
      transfer_date: "",
      transfer_time: "",
      full_name: "",
      project_name: "",
      address: "",
      sum_unit_used: 0,
      payment_list: JSON.parse(JSON.stringify(INITIAL_PAYMENT_LIST)),
      record_other_list: [],
      clement_remark: "",
      total_amount: 0.0,
      change_satang: 0.0,
      total_final: 0.0,
      add_on_add_debt: 0,
      add_on_reduce_debt: 0,
      add_on_add_debt_remark: "",
      add_on_reduce_debt_remark: "",
      total_pay: 0.0,
    });

  render() {
    const {
      iw_number,
      modal_permission,
      modal_some_pay,
      modal_pay,
      editable,
      data_customer,
      address_number,
      record_date,
      record_time,
      payment_type,
      transfer_date,
      transfer_time,
      full_name,
      project_name,
      address,
      payment_list,
      record_water_list,
      sum_unit_used,
      total_amount,
      change_satang,
      add_on_add_debt,
      add_on_reduce_debt,
      total_pay,
      username,
      password,
      record_water_list_change,
      ref_customer_id,
    } = this.state;

    const finalAmount = this.finalAmount();
    const paidRows = record_water_list.filter((w) => w.status);

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="ข้อมูลจัดเก็บค่าใช้จ่าย" page3="รับชำระค่าใช้จ่าย" />

        <div className="body">
          <div className="p-3">
            {/* หัวข้อ + ปุ่ม */}
            <div className="d-flex row mx-0 align-items-center justify-content-between">
              <h4 className="mb-3">
                <b>รับชำระค่าใช้จ่าย เลขที่ใบเสร็จ : {iw_number || "-"}</b>
              </h4>
              <div className="d-flex row mx-0">
                {perm.create && (
                  <button className="btn btn-outline-primary px-4 mx-1 mb-3" onClick={() => this.setState({ modal_permission: true })}>
                    แก้ไข
                  </button>
                )}
                {perm.create && (
                  <button className="btn btn-outline-primary px-4 mx-1 mb-3" onClick={this.openSomePay}>
                    ชำระบางส่วน
                  </button>
                )}
                <button className="btn btn-outline-primary px-4 mx-1 mb-3" onClick={() => (window.location.href = "/billing")}>
                  ย้อนกลับ
                </button>
              </div>
            </div>

            {/* ข้อมูลผู้ชำระ + วิธีการชำระ */}
            <div className="card border-0 px-3 pt-3 mb-3">
              <div className="row">
                <div className="col-12 col-lg-4 col-xl-3">
                  <label>บ้านเลขที่</label>
                  <Select
                    className="form-control bg-contain border-0 select-search w-100 mb-3"
                    styles={select_style}
                    options={data_customer || []}
                    onChange={(e) => this.GetByAddressNumber(e.value)}
                    value={data_customer?.find((item) => item.value === address_number) || null}
                  />
                </div>
                {/* วันที่/เวลา ล็อกไว้เป็นเวลาที่เปิดหน้า แก้ไม่ได้ */}
                <div className="col-6 col-lg-4 col-xl-3 mb-3">
                  <label>วันที่</label>
                  <DatePicker className="form-control bg-contain border-0" value={record_date} disabled />
                </div>
                <div className="col-6 col-lg-4 col-xl-3 mb-3">
                  <label>เวลา</label>
                  <input type="time" className="form-control w-100 bg-contain border-0" value={record_time} disabled />
                </div>

                <div className="col-12 col-lg-4 col-xl-3 mb-2">
                  <label>เลือกวิธีการชำระ</label>
                  <div className="d-flex" style={{ height: 60 }}>
                    <div className="d-flex wpx-100 align-items-center">
                      <input type="radio" checked={payment_type === PAYMENT_CASH} onChange={(e) => e.target.checked && this.setState({ payment_type: PAYMENT_CASH, transfer_date: "", transfer_time: "" })} />
                      <label className="mb-0 ml-3">เงินสด</label>
                    </div>
                    <div className="d-flex wpx-100 align-items-center">
                      <input type="radio" checked={payment_type === PAYMENT_TRANSFER} onChange={(e) => e.target.checked && this.setState({ payment_type: PAYMENT_TRANSFER, transfer_date: "", transfer_time: "" })} />
                      <label className="mb-0 ml-3">เงินโอน</label>
                    </div>
                  </div>
                </div>

                {/* ช่องเพิ่มเติมเมื่อเลือกเงินโอน */}
                {payment_type === PAYMENT_TRANSFER && (
                  <>
                    <div className="col-6 col-lg-4 col-xl-4 mb-3">
                      <label>วันที่โอน</label>
                      <DatePicker className="form-control bg-contain border-0" onChange={(e) => this.setState({ transfer_date: e })} value={transfer_date} />
                    </div>
                    <div className="col-6 col-lg-4 col-xl-4 mb-3">
                      <label>เวลาโอน</label>
                      <input type="time" className="form-control w-100 bg-contain border-0" onChange={(e) => this.setState({ transfer_time: e.target.value })} value={transfer_time} />
                    </div>
                    <div className="col-6 col-lg-4 col-xl-4 mb-3">
                      <label>รูปสลิปโอนเงิน</label>
                      <input type="file" accept="image/*" className="d-block w-100 border-0 pt-2 pb-0 px-2" style={{ appearance: "none", background: "none" }} multiple onChange={this.handleImageUpload} />
                    </div>
                  </>
                )}

                {/* ข้อมูลผู้ชำระ — มาจากบิล แก้ไม่ได้ */}
                <div className="col-12 col-md-4 mb-3">
                  <label>ชื่อ-นามสกุล</label>
                  <input type="text" className="form-control w-100 bg-contain border-0" value={full_name} disabled />
                </div>
                <div className="col-12 col-md-4 mb-3">
                  <label>ชื่อหน่วยงาน</label>
                  <input type="text" className="form-control w-100 bg-contain border-0" value={project_name} disabled />
                </div>
                <div className="col-12 col-md-4 mb-3">
                  <label>ที่อยู่</label>
                  <input type="text" className="form-control w-100 bg-contain border-0" value={address} disabled />
                </div>
              </div>
            </div>

            {/* ตารางรายการที่ต้องชำระ — ติ๊กเลือกได้เมื่อขอสิทธิ์แก้ไขแล้วเท่านั้น */}
            <div className="card border-0 p-3 mb-3">
              <div className="table-responsive">
                <table className="table table-borderless table-striped">
                  <thead>
                    <tr className="bg-dark-blue text-white">
                      <th className="text-center wpx-100">
                        <input type="checkbox" className="mr-2" checked={payment_list.every((item) => item.status_pay) && payment_list.length > 0} onChange={this.handleAllPaymentCheckboxChange} disabled={!editable} />
                        เลือก
                      </th>
                      <th className="text-center wpx-100">ลำดับที่</th>
                      <th className="text-center">รายการ</th>
                      <th className="text-center">ข้อมูลเพิ่มเติม</th>
                      <th className="text-right">ราคารวมสุทธิ</th>
                    </tr>
                  </thead>
                  <tbody>
                    {payment_list.map((item, index) => (
                      <tr key={index}>
                        <td className="text-center">
                          <input type="checkbox" checked={item.status_pay} onChange={() => this.handlePaymentCheckboxChange(index)} disabled={!editable} />
                        </td>
                        <td className="text-center">{NumberZero(index + 1)}</td>
                        <td>{PAYMENT_TITLES[item.title]}</td>
                        <td>
                          {/* แถวค่าน้ำแสดงจำนวนงวดที่ค้างและหน่วยน้ำรวม */}
                          {item.title === "water_bill" && (
                            <div className="d-flex justify-content-between">
                              {paidRows.length > 1 && <label>จำนวนงวด {paidRows.length - 1} งวด</label>}
                              <label></label>
                              <label>จำนวนหน่วยใช้ {sum_unit_used}</label>
                            </div>
                          )}
                        </td>
                        <td className="text-right">{toFixed(item.cost)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="card border-0 p-3 mb-3">
              <div className="w-100 d-flex justify-content-between">
                <b>จัดเก็บเงินทั้งสิ้น</b> <b>฿{toFixed(total_amount)}</b>
              </div>
            </div>

            {perm.create && (
              <button className="btn btn-outline-primary bg-white w-100 mb-4" onClick={this.openPayModal}>
                พิมพ์ใบเสร็จ
              </button>
            )}
          </div>
        </div>

        {/* popup ชำระบางส่วน — เลือกว่าจะชำระงวดไหนบ้าง */}
        <Modal show={modal_some_pay} onHide={this.closeSomePay} size="lg">
          <Modal.Header>
            <Modal.Title>
              <b>ชำระบางส่วน</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <table className="table table-borderless table-striped">
              <thead>
                <tr className="bg-dark-blue text-white">
                  <th className="text-center wpx-100">ลำดับที่</th>
                  <th className="text-center">ชื่อ-สกุล</th>
                  <th className="text-center">รายการค้างชำระรายเดือน</th>
                  <th className="text-center">ยอดเงินค้างชำระ</th>
                  <th className="text-center wpx-100">เลือก</th>
                </tr>
              </thead>
              <tbody>
                {record_water_list_change.map((item, index) => (
                  <tr key={index}>
                    <td className="text-center wpx-100">{NumberZero(index + 1)}</td>
                    <td className="text-center">{item.full_name}</td>
                    <td className="text-center">{format_date(item.datetime_create, "MMMM YYYY")}</td>
                    <td className="text-center">{toFixed(Number(item.total_amount))}</td>
                    <td className="text-center wpx-100">
                      {/* งวดของลูกหนี้คนอื่นจะติ๊กไม่ได้ */}
                      <input
                        type="checkbox"
                        className="mr-2"
                        checked={item.checked}
                        disabled={ref_customer_id !== "" && ref_customer_id !== item.ref_customer_id}
                        onChange={(e) => this.toggleSomePayRow(index, e.target.checked)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="w-100 d-flex">
              <div className="w-50 p-1">
                <button className="btn btn-outline-primary w-100" onClick={this.closeSomePay}>
                  ยกเลิก
                </button>
              </div>
              <div className="w-50 p-1">
                <button className="btn btn-primary w-100" onClick={this.confirmSomePay}>
                  บันทึก
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* popup รับเงิน */}
        <Modal show={modal_pay} onHide={() => this.setState({ modal_pay: false })}>
          <Modal.Header>
            <Modal.Title>
              <b>ชำระเงิน</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="w-100 mb-4 d-flex align-items-center">
              <span className="mr-3 wpx-64">รับเงิน:</span>
              <button className="btn btn-outline-primary w-100 mr-3" onClick={() => this.setState({ total_pay: finalAmount })}>
                ชำระเต็มจำนวน
              </button>
              <input className="form-control border-0 bg-contain text-right" type="text" onChange={(e) => float(e.target.value) && this.setState({ total_pay: e.target.value || 0 })} value={total_pay} maxLength={11} />
              <span className="ml-3">บาท</span>
            </div>

            <div className="w-100 mb-4 d-flex align-items-center">
              <span className="mr-3 w-100">ยอดชำระ:</span>
              <b>{toFixed(Number(total_amount))}</b>
              <span className="ml-3">บาท</span>
            </div>

            <div className="w-100 mb-4 d-flex align-items-center">
              <span className="mr-3 wpx-64">ปรับเศษ:</span>
              <input className="form-control border-0 bg-contain text-right" type="text" onChange={(e) => float(e.target.value, 3) && this.setState({ change_satang: e.target.value || 0 })} value={change_satang} maxLength={5} />
              <span className="ml-3">บาท</span>
            </div>

            <div className="w-100 mb-4 d-flex align-items-center">
              <span className="mr-3 wpx-64">เพิ่มหนี้:</span>
              <input className="form-control border-0 bg-contain text-right" type="text" onChange={(e) => float(e.target.value, 3) && this.setState({ add_on_add_debt: e.target.value || 0 })} value={add_on_add_debt} maxLength={9} />
              <span className="ml-3">บาท</span>
            </div>
            <div className="w-100 mb-4 d-flex align-items-center">
              <span className="mr-3 wpx-64">หมายเหตุเพิ่มหนี้:</span>
              <input className="form-control border-0 bg-contain text-right" type="text" placeholder="กรอกข้อมูล" onChange={(e) => this.setState({ add_on_add_debt_remark: e.target.value })} value={this.state.add_on_add_debt_remark} />
              <span className="ml-3">บาท</span>
            </div>

            <div className="w-100 mb-4 d-flex align-items-center">
              <span className="mr-3 wpx-64">ลดหนี้:</span>
              <input className="form-control border-0 bg-contain text-right" type="text" onChange={(e) => float(e.target.value, 3) && this.setState({ add_on_reduce_debt: e.target.value || 0 })} value={add_on_reduce_debt} maxLength={9} />
              <span className="ml-3">บาท</span>
            </div>
            <div className="w-100 mb-4 d-flex align-items-center">
              <span className="mr-3 wpx-64">หมายเหตุลดหนี้:</span>
              <input className="form-control border-0 bg-contain text-right" type="text" placeholder="กรอกข้อมูล" onChange={(e) => this.setState({ add_on_reduce_debt_remark: e.target.value })} value={this.state.add_on_reduce_debt_remark} />
              <span className="ml-3">บาท</span>
            </div>

            <div className="w-100 mb-4 d-flex align-items-center">
              <span className="mr-3 w-100">จัดเก็บเงินทั้งสิ้น:</span>
              <b>{toFixed(finalAmount)}</b>
              <span className="ml-3">บาท</span>
            </div>
            <div className="w-100 mb-4 d-flex align-items-center">
              <span className="mr-3 w-100">เงินทอน:</span>
              <b>{toFixed(Number(total_pay) - finalAmount)}</b>
              <span className="ml-3">บาท</span>
            </div>

            <div className="w-100 d-flex">
              <div className="w-50 p-1">
                <button className="btn btn-outline-primary w-100" onClick={() => this.setState({ modal_pay: false })}>
                  ยกเลิก
                </button>
              </div>
              <div className="w-50 p-1">
                <button className="btn btn-primary w-100" onClick={this.Create} disabled={this.state.disable_button}>
                  พิมพ์
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* popup ขอสิทธิ์แก้ไขรายการที่ชำระ */}
        <Modal show={modal_permission} onHide={() => this.setState({ modal_permission: false })}>
          <Modal.Header>
            <Modal.Title>
              <b>ขอสิทธิ์การแก้ไขข้อมูล</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="w-100 d-flex align-items-center mb-3">
              <label className="wpx-140">ชื่อผู้ใช้งาน{required}:</label>
              <input className="form-control border-0 bg-contain validate" type="text" onChange={(e) => this.setState({ username: e.target.value })} value={username} />
            </div>
            <div className="w-100 d-flex align-items-center mb-3">
              <label className="wpx-140">รหัสผ่าน{required}:</label>
              <input className="form-control border-0 bg-contain validate" type="password" onChange={(e) => this.setState({ password: e.target.value })} value={password} />
            </div>
            <div className="w-100 d-flex">
              <div className="w-50 p-1">
                <button className="btn btn-outline-primary w-100" onClick={() => this.setState({ modal_permission: false })}>
                  ยกเลิก
                </button>
              </div>
              <div className="w-50 p-1">
                <button className="btn btn-primary w-100" onClick={this.updatePermission}>
                  ยืนยัน
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
